import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DasFooterComponent } from "./components/das-live-views/das-footer/das-footer.component";
import { DasHeaderComponent } from "./components/das-live-views/das-header/das-header.component";
import { FooterComponent } from "./components/footer/footer.component";
import { HeaderComponent } from "./components/header/header.component";
import { LoginComponent } from "./components/header/login/login.component";
import { SubHeaderComponent } from "./components/sub-header/sub-header.component";
import { RouterModule } from '@angular/router';
import { SharedModule } from '../shared/shared.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MobileTabsComponent } from './components/mobile-tabs/mobile-tabs.component';


@NgModule({
  declarations: [
    DasHeaderComponent,
    HeaderComponent,
    FooterComponent,
    DasFooterComponent,
    SubHeaderComponent,
    LoginComponent,
    MobileTabsComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    SharedModule,
    FormsModule,
    ReactiveFormsModule
  ],
  exports: [
    DasHeaderComponent,
    HeaderComponent,
    FooterComponent,
    DasFooterComponent,
    SubHeaderComponent,
    LoginComponent,
    MobileTabsComponent
  ]
})
export class CoreModule { }
